import axios from "api/axios";

// App Backend
export const createPatientSession = async (sessionData) => {
  const response = await axios.post("/api/patient-sessions/", sessionData);
  return response.data;
};

// App Backend
export const updatePatientSession = async (id, sessionData) => {
  const response = await axios.patch(`/api/patient-sessions/${id}`, sessionData);
  return response.data;
};

// App Backend
export const getPatientSessionById = async (id) => {
  const response = await axios.get(`/api/patient-sessions/${id}`);
  return response.data;
};

